import React, { useMemo, useState } from 'react'
import { trans } from 'sharedKernel/i18n'
import { Prompt, useLocation, useParams } from 'react-router-dom'
import { MobileContainerPadding } from 'domain/feature/hub/company/scouting/FormWrapper/index.style'
import {
  OpportunityForm,
  mapScoutingOpportunityToForm,
} from 'domain/feature/hub/company/scouting/OpportunityForm'
import {
  ScoutingOpportunity,
  useGetOpportunityById,
} from 'domain/feature/hub/company/scouting/api/scoutingService'
import { Loading } from 'components/loading'

export const HubCompanyNewScoutingPage = (): JSX.Element => {
  const messageExit = trans('form.exitUnsavedChangesConfirm')
  const location = useLocation()
  const params = useParams() as { scoutingId?: string }

  const state = location.state as { opportunityId?: string } | undefined
  const opportunityId = params.scoutingId || state?.opportunityId

  const [isNavigationBlocked, setIsNavigationBlocked] = useState<boolean>(false)

  const {
    data: scoutingResponse,
    isFetching: isScoutingFetching,
  } = useGetOpportunityById(opportunityId || '')

  const scoutingData = scoutingResponse?.data as ScoutingOpportunity | undefined

  const initialData = useMemo(() => {
    if (opportunityId && scoutingData) {
      return mapScoutingOpportunityToForm(scoutingData)
    }
    return undefined
  }, [opportunityId, scoutingData])

  if (opportunityId && isScoutingFetching) {
    return <Loading />
  }

  return (
    <>
      <MobileContainerPadding />
      <Prompt when={isNavigationBlocked} message={messageExit} />
      <OpportunityForm
        key={`${opportunityId ?? 'new'}-${location.key}`}
        initialData={initialData}
        opportunityId={opportunityId}
        setIsNavigationBlocked={setIsNavigationBlocked}
      />
    </>
  )
}
